import Markdoc, { Config, Schema } from "@markdoc/markdoc";
import { DataSourceInstructionVariables } from "../../helper/dataSource/getDataSourceInstructions";

export const filesToExport: Schema = {
  render: "FilesToExport",
  children: ["tag"],
  transform(node, config: Config) {
    const variables = config.variables as DataSourceInstructionVariables;

    return new Markdoc.Tag(
      "FilesToExport",
      {
        dataSourceName: variables.dataSourceName ?? "",
      },
      node.transformChildren(config),
    );
  },
};

export const fileToExport: Schema = {
  selfClosing: true,
  render: "FileToExportRow",
  attributes: {
    name: {
      type: String,
      required: true,
    },
    fileType: {
      type: String,
      default: "CSV",
    },
    note: {
      type: String,
    },
  },
};
